<script setup>
/******************************************************************************
 * Component PageSection
 *****************************************************************************/
defineProps({
    hdl: {
        type: String,
        default: "",
    },
    centerHdl: {
        type: Boolean,
        default: false,
    },
});
</script>

<template>
    <section class="page-section">
        <header v-if="hdl">
            <h2 :class="{ centered: centerHdl }">{{ hdl }}</h2>
        </header>
        <slot />
    </section>
</template>

<style lang="scss" scoped>
.page-section {
    margin: 0 0 #{get($sizes, "base") * 0.6} 0;

    &:last-of-type {
        margin-bottom: 0;
    }

    @include respond-to("medium") {
        margin: 0 0 #{get($sizes, "base") * 1.2} 0;
    }
}

h2 {
    padding: 0 0 #{get($sizes, "base") * 0.6} 0;
    border-bottom: get($client, "appBorder");
    margin: 0 0 #{get($sizes, "base") * 0.6} 0;

    color: get($client, "appSectionHeadlineColor");

    font-size: #{get($sizes, "base") * 1.5};
    font-weight: 400;

    @include respond-to("medium") {
        margin: 0 0 #{get($sizes, "base") * 1.2} 0;
    }

    &.centered {
        text-align: center;
    }
}
</style>
